import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";

const ITEM_HEIGHT = 48;

class FeedTypeMenu extends React.Component {
  state = {
    anchorEl: null
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { playId, videos, selected, store } = this.props;
    const { anchorEl } = this.state;

    return (
      <div>
        <IconButton
          aria-label="More"
          aria-owns={anchorEl ? "long-menu" : null}
          aria-haspopup="true"
          onClick={this.handleClick}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: 200
            }
          }}
        >
          {videos.map(video => (
            <MenuItem
              key={video.link}
              selected={video.feedType === selected}
              onClick={() => {
                store.updateActiveVideoForPlay(playId, video);
                this.handleClose();
              }}
            >
              {video.feedType}
            </MenuItem>
          ))}
        </Menu>
      </div>
    );
  }
}

export default FeedTypeMenu;



// WEBPACK FOOTER //
// ./src/components/FeedTypeMenu.js